import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  BottomSection,
  LeftSection,
  RightSection,
  SectionsState,
  TopSection,
} from '../types';

const initialState: SectionsState = {
  fullScreen: false,
  topSection: {
    menuBar: { isVisible: true, height: 40 },
    toolBar: { isVisible: true, height: 40 },
    formulaBar: { isVisible: false, height: 22 },
  },
  rightSection: {
    sideWindow: { isVisible: false, width: 0 },
  },
  bottomSection: {
    bottomBar: { isVisible: true, height: 30 },
    // formulaBar: { isVisible: false, height: 0 },
  },
  leftSection: {},
};

const sectionsSlice = createSlice({
  name: 'sections',
  initialState,
  reducers: {
    resetSections: () => {
      return initialState;
    },
    addSections: (state, action: PayloadAction<Partial<SectionsState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTopSection: (state, action: PayloadAction<Partial<TopSection>>) => {
      state.topSection = {
        ...state.topSection,
        ...action.payload,
      };
    },
    updateRightSection: (
      state,
      action: PayloadAction<Partial<RightSection>>
    ) => {
      state.rightSection = {
        ...state.rightSection,
        ...action.payload,
      };
    },
    updateBottomSection: (
      state,
      action: PayloadAction<Partial<BottomSection>>
    ) => {
      state.bottomSection = {
        ...state.bottomSection,
        ...action.payload,
      };
    },
    updateLeftSection: (state, action: PayloadAction<Partial<LeftSection>>) => {
      state.leftSection = {
        ...state.leftSection,
        ...action.payload,
      };
    },
    toggleFullScreen: (state) => {
      state.fullScreen = !state.fullScreen;
    },
  },
});

export const {
  addSections,
  resetSections,

  updateTopSection,
  updateRightSection,
  updateBottomSection,
  updateLeftSection,
  toggleFullScreen,
} = sectionsSlice.actions;
export default sectionsSlice.reducer;
